import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.CATEGORY,
  primaryKey: 'id',
  properties: {
    id: 'int',
    name: 'string',
    note: 'string?',
    icon: 'string?',
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
